//
// Copyright 2021 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import BusinessIcon from "@material-ui/icons/Business";
import UploadFileWithConfigurationButton from "src/components/loader/buttons/UploadFileWithConfigurationButton";

const ImportLayoutButton = (props) => {
  return (
    <UploadFileWithConfigurationButton
      label="Import Layouts"
      url="loader/importLayout"
      icon={<BusinessIcon/>}
      {...props}
    />
  );
};
export default ImportLayoutButton;
